import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Mail, Phone, MapPin, MessageCircle } from "lucide-react";
import { CONTACT } from "@/config/contact";
import NewsletterForm from "./NewsletterForm";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-24 border-t border-stone-200 bg-white">
      <div className="container-cnp py-14 border-b border-stone-200/70">
        <div className="grid lg:grid-cols-2 gap-8 items-center">
          <div>
            <div className="tag-chip">Newsletter semanal</div>
            <h3 className="mt-3 font-display text-2xl md:text-3xl text-stone-900">Os melhores imóveis da semana, direto no seu email.</h3>
            <p className="mt-2 text-stone-600 text-sm max-w-lg">Todas as segundas. Curto, útil, e apenas com o que interessa no Grande Porto.</p>
          </div>
          <div>
            <NewsletterForm variant="footer" testid="footer-newsletter" />
          </div>
        </div>
      </div>
      <div className="container-cnp py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2 space-y-4">
          <img src="/logo.png" alt="casa no porto" className="h-10 w-auto" />
          <p className="max-w-md text-stone-600">
            Consultoria imobiliária local no Porto e Grande Porto, com um serviço humano, transparente
            e focado em resultados. Zélia Silva, associada à eXp Portugal.
          </p>
          <div className="flex items-center gap-3 pt-2">
            <a href={CONTACT.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="rounded-full border border-stone-200 p-2 text-stone-700 hover:text-[#103C4A]">
              <Instagram className="h-4 w-4" />
            </a>
            <a href={CONTACT.facebook} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="rounded-full border border-stone-200 p-2 text-stone-700 hover:text-[#103C4A]">
              <Facebook className="h-4 w-4" />
            </a>
            <a href={CONTACT.whatsappUrl} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="rounded-full border border-stone-200 p-2 text-stone-700 hover:text-[#103C4A]">
              <MessageCircle className="h-4 w-4" />
            </a>
          </div>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-widest text-stone-500 mb-4">Navegar</h4>
          <ul className="space-y-2 text-stone-700">
            <li><Link data-testid="footer-nav-comprar" to="/comprar-casa-no-porto" className="link-underline">Comprar casa no Porto</Link></li>
            <li><Link data-testid="footer-nav-vender" to="/vender-casa-no-porto" className="link-underline">Vender casa no Porto</Link></li>
            <li><Link data-testid="footer-nav-zonas" to="/zonas" className="link-underline">Zonas</Link></li>
            <li><Link data-testid="footer-nav-blog" to="/blog" className="link-underline">Blog</Link></li>
            <li><Link data-testid="footer-nav-sobre" to="/sobre" className="link-underline">Sobre a Zélia</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="text-sm uppercase tracking-widest text-stone-500 mb-4">Contacto</h4>
          <ul className="space-y-3 text-stone-700 text-sm">
            <li className="flex flex-wrap items-baseline gap-x-2 gap-y-0"><Phone className="h-4 w-4 text-[#103C4A] shrink-0 self-center" /> <a href={`tel:${CONTACT.phoneRaw}`} className="link-underline">{CONTACT.phone}</a></li>
            <li className="flex items-center gap-2"><MessageCircle className="h-4 w-4 text-[#103C4A]" /> <a href={CONTACT.whatsappUrl} target="_blank" rel="noreferrer" className="link-underline">WhatsApp</a></li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#103C4A]" /> <a href={`mailto:${CONTACT.email}`} className="link-underline">{CONTACT.email}</a></li>
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#103C4A]" /> Porto e Grande Porto</li>
          </ul>
          <div className="mt-6">
            <Link data-testid="footer-cta-avaliacao" to="/avaliacao-gratuita" className="btn-primary">
              Avaliação gratuita
            </Link>
          </div>
        </div>
      </div>
      <div className="border-t border-stone-200">
        <div className="container-cnp py-6 text-xs text-stone-500">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
            <div>© {new Date().getFullYear()} casa no porto · Zélia Silva · Consultora eXp Portugal</div>
            <div className="flex items-center gap-4">
              <Link data-testid="footer-privacy" to="/politica-de-privacidade" className="hover:text-[#103C4A]">Política de privacidade</Link>
              <Link data-testid="footer-terms" to="/termos" className="hover:text-[#103C4A]">Termos</Link>
            </div>
          </div>
          <div className="mt-3 text-[11px] leading-relaxed text-stone-500">
            A eXp Realty, a operar em Portugal sob a denominação eXp Global Portugal, Lda., é uma mediadora imobiliária titular da licença AMI 18470, com sede na Praça Marquês de Pombal, n.º 14, 1250-162 Lisboa.
          </div>
        </div>
      </div>
    </footer>
  );
}
